import './App.css';
import "antd/dist/antd.css";
import {  Layout } from 'antd';

import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router } from "react-router-dom";
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'

import Amplify, {Auth} from 'aws-amplify';
import { withAuthenticator } from '@aws-amplify/ui-react';

import * as AuthActions from './store/auth/actions';
import * as AuthSelectors from './store/auth/selectors';

import Navbar from './shared/navbar/Navbar';

import {ADMIN_PROFILE, CLIENT_PROFILE} from './interfaces/auth.interface'

import awsExports from "./aws-exports";


import { I18n } from "aws-amplify";
import { Translations } from "@aws-amplify/ui-components";




Amplify.configure(awsExports);
I18n.setLanguage('ru');

I18n.putVocabulariesForLanguage("ru", {
  [Translations.SIGN_IN_HEADER_TEXT]: "Вход в Archicam|Lab",
  [Translations.SIGN_IN_ACTION]: "войти",
  [Translations.FORGOT_PASSWORD_TEXT]: "Забыли пароль?",
  [Translations.RESET_PASSWORD_TEXT]: "восстановить пароль",
  [Translations.NO_ACCOUNT_TEXT]: "Еще не зарегистрировались?",
  [Translations.CREATE_ACCOUNT_TEXT]: "Зарегистрироватся",
  [Translations.USERNAME_LABEL]: "Имя пользователя",
  [Translations.USERNAME_PLACEHOLDER]: "Введите имя пользователя",
  [Translations.PASSWORD_LABEL]: "Пароль",
  [Translations.PASSWORD_PLACEHOLDER]: "Введите пароль",
  [Translations.RESET_PASSWORD_TEXT]: "Сброс пароля",
  [Translations.BACK_TO_SIGN_IN]: "Вернуться ко входу",
  [Translations.SEND_CODE]: "Отправить код",
  [Translations.SIGN_UP_HEADER_TEXT]:"Регистрация",
  [Translations.SIGN_UP_USERNAME_PLACEHOLDER]:"Имя пользователя это ваш email",
  [Translations.SIGN_UP_PASSWORD_PLACEHOLDER]:"Пароль",
  [Translations.SIGN_UP_EMAIL_PLACEHOLDER]:"Email",
  [Translations.PHONE_LABEL]:"Номер телефона",
  [Translations.EMAIL_LABEL]:"Email",
  [Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]:"Сохранить",
  [Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]:"Уже зарегистрировались?",
  [Translations.SIGN_IN_TEXT]:"войти",
  [Translations.EMPTY_USERNAME]:"Имя пользователя не должно быть пустым",
  [Translations.EMPTY_PASSWORD]:"Пароль не должен быть пустым"
});


//Layout Setting
const { Content, Footer } = Layout;
const ProfileContainer = ({profile}) => {
  switch (profile) {
    case CLIENT_PROFILE:
      const ClientApp = React.lazy(() => import('./modules/ClientApp'))
      return <Suspense fallback={<div>Loading</div>}><ClientApp/></Suspense>
    case ADMIN_PROFILE:
      const AdminApp =React.lazy(() => import('./modules/AdminApp'))
      return <Suspense fallback={<div>Loading</div>}><AdminApp/></Suspense> 
    default:
      return null;
  }
}


const App = () => {
  const userProfile = useSelector(AuthSelectors.selectUserProfile)
  const dispatch = useDispatch()

  useEffect(() => {
      async function getUserGroup() {
        const user =  await Auth.currentAuthenticatedUser();
        const { identityId } = await Auth.currentCredentials()
        const { attributes : {email} } = user
        const groups = user.signInUserSession.accessToken.payload["cognito:groups"]
        const userProfile = groups ? groups.includes('admins') ? ADMIN_PROFILE : CLIENT_PROFILE :  CLIENT_PROFILE
        
        dispatch(AuthActions.setUserProfile(userProfile))
        dispatch(AuthActions.setUserEmail(email))
        dispatch(AuthActions.setUserIdentityId(identityId))
    }
    getUserGroup()
           
  }, [dispatch]);

return (
  <Router>
  <Layout className="layout">
    <Navbar/>
    <Content style={{ padding: '0 50px' }}>
      <ProfileContainer profile={userProfile}/>
    </Content>
    <Footer style={{ textAlign: 'center' }}>Dev</Footer>
  </Layout>
  </Router>
  ) 
}

export default withAuthenticator(App, {
  usernameAttributes: 'email'
});
